const CURRENCY_FORMATTER_CACHE: Record<string, { format: (num: number) => string }> = {};

export default function (currency: string, LANGUAGE: string) {
  const key = `${currency}-${LANGUAGE}`;
  const existing = CURRENCY_FORMATTER_CACHE[key];

  if (existing) {
    return existing;
  }

  const formatter = new Intl.NumberFormat(LANGUAGE, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol"
  });

  CURRENCY_FORMATTER_CACHE[key] = {
    format: (num: number) => formatter.format(num).replace(/\s/g, '')
  };

  return CURRENCY_FORMATTER_CACHE[key];
}
